import api from "./ApiService";
import { getHeaders } from "../helpers/utils";

const upsert = async ({
  id,
  estateId,
  owner,
  documentTypeId,
  startDate,
  endDate,
  data,
}) => {
  const res = await api.post(
    "Document/Draft",
    { id, estateId, owner, documentTypeId, startDate, endDate, data },
    { headers: getHeaders() }
  );
  return res.data;
};

const getByEstateId = async (estateId) => {
  const res = await api.get(`Document/Draft/Estate/${estateId}`, {
    headers: getHeaders(),
  });
  return res.data;
};

const getById = async (draftId) => {
  const res = await api.get(`Document/Draft/${draftId}`, {
    headers: getHeaders(),
  });
  return res.data;
};

const remove = async (draftId) => {
  const res = await api.delete(`Document/Draft/${draftId}`, {
    headers: getHeaders(),
  });
  return res.data;
};

const DocumentDraftService = { upsert, getByEstateId, getById, remove };

export default DocumentDraftService;
